function openListMultichoice() {
   let showSelect = document.getElementById("multichoice");
   let itens      = document.getElementById("select__itens-multichoice");
   let icon       = document.getElementById("select__button-OpenClose multichoice");
   let clean      = document.getElementById("select__button-clean");

   clean.classList.toggle('mostra__select');
   showSelect.classList.toggle('mostra__select');
   itens.classList.toggle('mostra__select');
   icon.classList.toggle('icon');
}

function toClean() {
   var checkboxes = document.querySelectorAll('input[type=checkbox]');
   for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false;
   }
}